import React from "react";

const EmptyState = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-col items-center pb-3">
      <img src="empty_state.svg" alt="Empty State Illustration" />
      <p className="text-sm mt-4">{text}</p>
    </div>
  );
};

export default EmptyState;
